
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PasswordProtection from "./components/PasswordProtection";
import Index from "./pages/Index";
import Services from "./pages/Services";
import Emergency from "./pages/Emergency";
import EmergencyRequest from "./pages/EmergencyRequest";
import EmergencyConfirmation from "./pages/EmergencyConfirmation";
import BookingConfirmation from "./pages/BookingConfirmation";
import CaregiverProfile from "./pages/CaregiverProfile";
import CareBubble from "./pages/CareBubble";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <PasswordProtection>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/services" element={<Services />} />
            <Route path="/caregivers" element={<Services />} /> {/* Using the Services page for now */}
            <Route path="/emergency" element={<Emergency />} />
            <Route path="/emergency-request" element={<EmergencyRequest />} />
            <Route path="/emergency-confirmation" element={<EmergencyConfirmation />} />
            <Route path="/booking-confirmation" element={<BookingConfirmation />} />
            <Route path="/caregiver/:caregiverId" element={<CaregiverProfile />} />
            <Route path="/bubble" element={<CareBubble />} />
            <Route path="/sphere" element={<CareBubble />} /> {/* Keep old route for compatibility */}
            <Route path="/admin" element={<AdminDashboard />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PasswordProtection>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
